import { Routes } from '@angular/router';

import { authGuard } from './shared/guards/auth.guard';

export const routes: Routes = [
  {
    path: '',
    loadComponent: () => import('./features/home/home.component').then((m) => m.HomeComponent),
    canActivate: [authGuard],
    pathMatch: 'full',
  },
  {
    path: 'login',
    loadComponent: () =>
      import('./features/auth/login/login.component').then((m) => m.LoginComponent),
  },
  {
    path: 'day-pass',
    loadComponent: () => import('./features/home/home.component').then((m) => m.HomeComponent),
    canActivate: [authGuard],
  },
  {
    path: 'meeting-rooms',
    loadComponent: () => import('./features/home/home.component').then((m) => m.HomeComponent),
    canActivate: [authGuard],
  },
  {
    path: 'day-pass/:buildingId/booking',
    loadComponent: () =>
      import('./features/day-pass/day-pass-booking.component').then(
        (m) => m.DayPassBookingComponent,
      ),
    canActivate: [authGuard],
  },
  {
    path: 'meeting-rooms/:buildingId/booking/:roomId',
    loadComponent: () =>
      import('./features/meeting-rooms/meeting-room-booking.component').then(
        (m) => m.MeetingRoomBookingComponent,
      ),
    canActivate: [authGuard],
  },
  {
    path: 'meeting-rooms/:buildingId',
    loadComponent: () =>
      import('./features/meeting-rooms/meeting-room-details.component').then(
        (m) => m.MeetingRoomDetailsComponent,
      ),
    canActivate: [authGuard],
  },
  {
    path: 'account',
    redirectTo: 'account/personal-details',
    pathMatch: 'full',
  },
  {
    path: 'account/personal-details',
    canActivate: [authGuard],
    loadComponent: () =>
      import('./features/myaccount/myaccount.component').then((m) => m.MyAccountComponent),
  },
  {
    path: 'account/bookings',
    canActivate: [authGuard],
    loadComponent: () =>
      import('./features/myaccount/myaccount.component').then((m) => m.MyAccountComponent),
  },
  {
    path: 'account/logout',
    canActivate: [authGuard],
    loadComponent: () =>
      import('./features/myaccount/myaccount.component').then((m) => m.MyAccountComponent),
  },
  {
    path: 'booking-success/:bookingType/:bookingId',
    canActivate: [authGuard],
    loadComponent: () =>
      import('./features/booking-success/booking-success.component').then(
        (m) => m.BookingSuccessComponent,
      ),
  },
  { path: 'myaccount', redirectTo: 'account', pathMatch: 'full' },
  { path: '**', redirectTo: 'login' },
];
